import { render, staticRenderFns } from "./FileDropTemplate.vue?vue&type=template&id=61714938&"
import script from "./FileDropTemplate.vue?vue&type=script&lang=js&"
export * from "./FileDropTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports